import ReactApexChart from "react-apexcharts";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { FinanceTitle } from "../../../../Constants/Constants";
import { FinanceChart } from "../../../../Data/General/Widgets/Chart";

const Finance = () => {
  return (
    <Col xl="5" lg="12" className="box-col-5">
      <Card>
        <CommonCardHeader title={FinanceTitle} />
        <CardBody>
          <div className="chart-container column-container">
            <ReactApexChart id="columnchart" options={FinanceChart} series={FinanceChart.series} type="line" height={350} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default Finance;
